const isAnswerEmpty = (answer) => answer === '' || typeof answer === 'undefined';

export default isAnswerEmpty;
